export const getEnumKeyByEnumValue = <T extends { [index: string]: string }>(
  myEnum: T,
  enumValue: string
): keyof T | null => Object.keys(myEnum).find((key) => myEnum[key] === enumValue) ?? null;

export const getTextInitials = (name: string) => {
  return name.split(' ').reduce((acc, elm) => {
    return acc.concat(elm.charAt(0).toUpperCase());
  }, '');
};
